import { useCallback, useEffect, useRef, useState } from 'react';

function useOtpTimer(cooldown: number, onCooldownComplete?: () => void) {
  const [timer, setTimer] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const callbackRef = useRef(onCooldownComplete);

  // Update the callback ref when the callback changes
  useEffect(() => {
    callbackRef.current = onCooldownComplete;
  }, [onCooldownComplete]);

  useEffect(() => {
    if (timer > 0) {
      intervalRef.current = setInterval(() => {
        setTimer(prev => {
          if (prev <= 1) {
            clearInterval(intervalRef.current!);
            intervalRef.current = null;
            // Use the ref to avoid calling during render
            if (callbackRef.current) {
              setTimeout(() => {
                callbackRef.current?.();
              }, 0);
            }
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [timer]);

  const startTimer = useCallback(() => setTimer(cooldown), [cooldown]);

  return [timer, startTimer] as const;
}

export { useOtpTimer };
